import { ReactiveVar, useReactiveVar } from '@apollo/client'
import { ColDef, GridApi } from 'ag-grid-community'
import { CONTEXT_MENU_OFFSET_PX } from 'components/AgGrid/config/constants'
import AgContextMenu from './AgContextMenu'
import { getHeaderContextMenuItems } from './menuItems/menuItems'

interface AgContextMenuContainerProps {
  gridApi?: GridApi
  columnHeaderRightClickMenuVar: ReactiveVar<any>
  columnDefs: ColDef[]
  tableKey: string
  hideCustomizeColumns?: boolean
}

const AgContextMenuContainer = ({
  gridApi,
  columnHeaderRightClickMenuVar,
  columnDefs,
  tableKey,
  hideCustomizeColumns = false,
}: AgContextMenuContainerProps) => {
  const isColumnHeaderRightClickMenu = useReactiveVar(columnHeaderRightClickMenuVar)

  if (!gridApi) {
    return null
  }

  return (
    <>
      {isColumnHeaderRightClickMenu && (
        <AgContextMenu
          items={getHeaderContextMenuItems(
            isColumnHeaderRightClickMenu,
            gridApi,
            columnHeaderRightClickMenuVar,
            columnDefs,
            tableKey,
            hideCustomizeColumns
          )}
          onClose={() => columnHeaderRightClickMenuVar(false)}
          anchorPosition={{
            top: parseInt(
              `${isColumnHeaderRightClickMenu.mouseEvent.clientY + CONTEXT_MENU_OFFSET_PX}`
            ),
            left: isColumnHeaderRightClickMenu?.mouseEvent.clientX,
          }}
        />
      )}
    </>
  )
}

export default AgContextMenuContainer
